<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top" :rules="searchRules" ref="searchFormRef">
                        <div class="grid gap-4"
                            :class="[
                                loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-6' : 'md:grid-cols-5',
                            ]">
                            <el-form-item class="no-margin"
                                v-if="loginUserRole === ROLES.SYSTEM" label="組織" prop="organization_id">
                                <OrganizationSelect v-model="searchForm.organization_id" placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="払出元部門" prop="target_department_id">
                                <DepartmentSelect 
                                    :organization-id="searchForm.organization_id" 
                                    v-model="searchForm.target_department_id" 
                                    :is-exclude-target-department="true"
                                    :target-department-id="searchForm.dest_department_id"
                                    @department-name-change="handleTargetDepartmentNameChange($event)"
                                    @organization-id-change="searchForm.organization_id = $event"
                                    placeholder="払出元部門を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="払出先部門" prop="dest_department_id">
                                <DepartmentSelect 
                                    :organization-id="searchForm.organization_id" 
                                    v-model="searchForm.dest_department_id" 
                                    :is-exclude-target-department="true"
                                    :target-department-id="searchForm.target_department_id"
                                    @department-name-change="handleDestDepartmentNameChange($event)"
                                    @organization-id-change="searchForm.organization_id = $event"
                                    placeholder="払出先部門を選択" />
                            </el-form-item>

                            <!-- 占位 -->
                            <!-- <div v-if="loginUserRole !== ROLES.SYSTEM"></div> -->

                            <el-form-item class="no-margin" label="カテゴリ">
                                <CategorySelect :organization-id="searchForm.organization_id"
                                    v-model="searchForm.category_id" :is-search="true" placeholder="カテゴリを選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="アイテム名">
                                <AutoCompleteInput 
                                    v-model="searchForm.material_name" 
                                    placeholder="アイテム名を入力"
                                    storage-key="material-name-history"
                                    :max-history-items="15"
                                    ref="materialNameInput"
                                />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton(searchFormRef)">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top" :rules="searchRules" ref="searchFormRef">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin"
                                    v-if="loginUserRole === ROLES.SYSTEM" label="組織" prop="organization_id">
                                    <OrganizationSelect v-model="searchForm.organization_id" placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="払出元部門" prop="target_department_id">
                                    <DepartmentSelect 
                                        :organization-id="searchForm.organization_id" 
                                        v-model="searchForm.target_department_id" 
                                        :is-exclude-target-department="true"
                                        :target-department-id="searchForm.dest_department_id"
                                        @department-name-change="handleTargetDepartmentNameChange($event)"
                                        @organization-id-change="searchForm.organization_id = $event"
                                        placeholder="払出元部門を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="払出先部門" prop="dest_department_id">
                                    <DepartmentSelect 
                                        :organization-id="searchForm.organization_id" 
                                        v-model="searchForm.dest_department_id" 
                                        :is-exclude-target-department="true"
                                        :target-department-id="searchForm.target_department_id"
                                        @department-name-change="handleDestDepartmentNameChange($event)"
                                        @organization-id-change="searchForm.organization_id = $event"
                                        placeholder="払出先部門を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="カテゴリ">
                                    <CategorySelect :organization-id="searchForm.organization_id"
                                        v-model="searchForm.category_id" :is-search="true" placeholder="カテゴリを選択" />
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="アイテム名">
                                        <AutoCompleteInput 
                                            v-model="searchForm.material_name" 
                                            placeholder="アイテム名を入力"
                                            storage-key="material-name-history"
                                            :max-history-items="15"
                                            ref="materialNameInput"
                                        />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton(searchFormRef)" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info"
                        @click="handleProcessButton" circle>
                        <span class="material-symbols-outlined">
                            trolley
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info"
                        @click="handleProcessButton">処理</el-button>
                </div>
            </div>
        </el-header>

        <el-main style="padding: 0px; padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>払い出し（アイテム名　在庫数）</span>
                    <div class="ml-auto">                        
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('material_name')"
                                :class="['mobile-sort-btn', sortField === 'material_name' ? 'active' : '']">
                                アイテム名
                            </el-button>
                            <el-button 
                                size="small" 
                                @click="handleSort('storage_date')"
                                :class="['mobile-sort-btn', sortField === 'storage_date' ? 'active' : '']">
                                保管日
                            </el-button>
                            <el-button 
                                size="small" 
                                @click="handleSort('expiration_date')"
                                :class="['mobile-sort-btn', sortField === 'expiration_date' ? 'active' : '']">
                                有効期限
                            </el-button>
                            <span class="text-white">アイテム数: {{ totalRecords }}</span>
                        </div>
                    </div>
                </div>

                <div style="overflow-y: auto; height: calc(100vh - 177px)">
                    <div v-if="tableData.length === 0 && (!searchForm.organization_id || !searchForm.target_department_id || !searchForm.dest_department_id)"
                        class="flex justify-center items-center h-full text-gray-500">
                        組織、払出元部門、払出先部門を選択してください
                    </div>
                    
                    <el-card v-for="item in tableData" :key="item.inventory_id"
                        style="border: 1px solid #d1d5db; border-radius: 0px">
                        <div class="flex flex-col justify-between">
                            <div>{{ item.material_name }}</div>
                            <div class="text-sm text-gray-500">{{ item.category_name }}</div>
                        </div>

                        <el-row align="middle">
                            <el-col :span="19">
                                <div class="flex flex-col">
                                    <div>保管日: {{ formatDate(item.storage_date!) }}</div>
                                    <div :class="{ 'text-red-500': isExpired(item.expiration_date) }">
                                        有効期限: {{ formatDate(item.expiration_date) }}                        
                                    </div>
                                    
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="flex justify-end text-2xl">{{ item.quantity }}</div>
                            </el-col>
                        </el-row>

                        <div v-if="item.quantity > 0" class="flex items-center">
                            <span>払い出し方法: </span>
                            <el-tag type="info" v-if="item.payMode === 0">新規</el-tag>
                            <el-tag type="primary" v-if="item.payMode === 1">選択</el-tag>
                            <el-tag type="success" v-if="item.payMode === 2">追加</el-tag>
                            <span v-if="item.payMode === 1" class="material-symbols-outlined cursor-pointer"
                                @click="handlePayModeButton(item)">
                                stat_minus_1
                            </span>
                        </div>
                        <div v-if="item.quantity > 0" class="flex items-center">
                            <span>払出数量: </span>
                            <el-form-item class="no-margin">
                                <el-input-number 
                                    v-model="item.payQuantity" 
                                    :min="0" 
                                    :max="item.quantity" 
                                    :value-on-clear="0"
                                    @focus="handlePayQuantityChange(item)"
                                    @change="handlePayQuantityChange(item)" />
                            </el-form-item>
                        </div>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="tableData" height="calc(100vh - 290px)" v-loading="loading">
                <el-table-column prop="organization_name" label="組織" width="120" />
                    <el-table-column prop="department_name" label="部署" width="120" />
                    <el-table-column prop="category_name" label="カテゴリ" width="100">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('category_name')">
                                <span>{{ getSortLabel('category_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'category_name' }">
                                        {{ getSortIcon('category_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="material_name" label="アイテム名">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('material_name')">
                                <span>{{ getSortLabel('material_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'material_name' }">
                                        {{ getSortIcon('material_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="storage_date" label="保管日" width="200">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('storage_date')">
                                <span>{{ getSortLabel('storage_date') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'storage_date' }">
                                        {{ getSortIcon('storage_date') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            {{ formatDate(scope.row.storage_date) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="expiration_date" label="有効期限" width="200">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('expiration_date')">
                                <span>{{ getSortLabel('expiration_date') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'expiration_date' }">
                                        {{ getSortIcon('expiration_date') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            <span :class="{ 'text-red-500': isExpired(scope.row.expiration_date) }">
                                {{ formatDate(scope.row.expiration_date) }}                        
                            </span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="quantity" label="在庫数" width="70" header-align="center" align="right">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('quantity')">
                                <span>{{ getSortLabel('quantity') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'quantity' }">
                                        {{ getSortIcon('quantity') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="払い出し方法" width="120" align="center">
                        <template #default="scope">
                            <div v-if="scope.row.quantity > 0" class="w-16 flex items-center">
                                <el-tag type="info" v-if="scope.row.payMode === 0">新規</el-tag>
                                <el-tag type="primary" v-if="scope.row.payMode === 1">選択</el-tag>
                                <el-tag type="success" v-if="scope.row.payMode === 2">追加</el-tag>
                                <span v-if="scope.row.payMode === 1" class="material-symbols-outlined cursor-pointer"
                                    @click="handlePayModeButton(scope.row)">
                                    stat_minus_1
                                </span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="払出数量" width="150" align="center">
                        <template #default="scope">
                            <el-form-item v-if="scope.row.quantity > 0" class="no-margin">
                                <el-input-number 
                                    v-model="scope.row.payQuantity" 
                                    :min="0" 
                                    :max="scope.row.quantity" 
                                    :value-on-clear="0"
                                    @focus="handlePayQuantityChange(scope.row)"
                                    @change="handlePayQuantityChange(scope.row)" />
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="メモ" width="100" align="center">
                        <template #default="scope">
                            <div v-if="scope.row.quantity > 0" class="flex items-center justify-center">
                                <div class="flex items-center">
                                    <el-button 
                                        size="small" 
                                        type="primary" 
                                        @click="openMemoDialog(scope.row)">
                                        編集
                                    </el-button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <!-- <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="totalRecords" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="totalRecords"
                    @current-change="handleCurrentChange" />
                </div>
            </div> -->
        </el-main>
    </el-container>

    <!-- 払い出し确认对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="dialogFormVisible" style="max-width:800px"
        :title="!processing ? '払い出し確認' : '払い出し完了'" align-center>
        <el-form :model="payForm" :rules="payRules" ref="payFormRef">
            <div class="flex flex-col md:flex-row">
                <div class="flex-1">
                    <el-form-item label="部門（元）" label-width="120px">
                        <DepartmentSelect 
                            :organization-id="payForm.organization_id"
                            v-model="payForm.target_department_id"
                            :disabled="true" />
                    </el-form-item>
                </div>
                        
                <div class="flex-1">
                    <el-form-item label="部門（先）" label-width="120px">
                        <DepartmentSelect 
                            :organization-id="payForm.organization_id"
                            v-model="payForm.dest_department_id"
                            :disabled="true" />
                    </el-form-item>
                </div>
            </div>
            <div class="flex flex-col md:flex-row">
                <div class="flex-1">
                    <el-form-item label="操作者" prop="transfer_operator" label-width="120px">
                        <el-input maxlength="10" v-model="payForm.transfer_operator" placeholder="操作者を入力" autocomplete="off" :disabled="processing" />
                    </el-form-item> 
                </div>
                <div class="flex-1"></div>
            </div>
        </el-form>
        <el-table 
            v-loading="loading2"
            :data="payForm.details" 
            style="width: 100%;"
            highlight-current-row
            header-row-class-name="table-header-row">
            <el-table-column prop="material_name" label="アイテム名" :width="processing ? 246 : 298" />
            <el-table-column prop="storage_date" label="保管日" header-align="center" width="100">
                <template #default="scope">
                    {{ formatDate(scope.row.storage_date) }}
                </template>
            </el-table-column>
            <el-table-column prop="expiration_date" label="有効期限" header-align="center" width="100">
                <template #default="scope">
                    <span :class="{ 'text-red-500': isExpired(scope.row.expiration_date) }">
                        {{ formatDate(scope.row.expiration_date) }}                        
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="quantity" label="在庫数" width="70" header-align="center" align="right" />
            <el-table-column label="払い出し方法" width="120" align="center">
                <template #default="scope">
                    <el-tag type="info" v-if="scope.row.payMode === 0">新規</el-tag>
                    <el-tag type="primary" v-if="scope.row.payMode === 1">選択</el-tag>
                    <el-tag type="success" v-if="scope.row.payMode === 2">追加</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="payQuantity" label="払出数量" width="80" align="right" />

            <el-table-column v-if="processing" prop="" label="状態" width="52" align="center">
                <template #default="scope">
                    <div v-if="scope.row.process_status === 1">
                        <el-icon color="#67C23A">
                            <SuccessFilled />
                        </el-icon>
                    </div>
                    <div v-else-if="scope.row.process_status === 2">
                        <el-icon color="#F56C6C">
                            <CircleCloseFilled />
                        </el-icon>
                    </div>
                    <div v-else>
                        <el-icon color="#909399">
                            <Loading />
                        </el-icon>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <template #footer>
            <div v-if="!processing" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleSubmit(payFormRef)">
                    確認
                </el-button>
            </div>
            <div v-if="processing" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">
                    閉じる
                </el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 払い出し对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="selectedTargetInventorydialogFormVisible" style="max-width:800px"
        title="払い出し" align-center>
        <div>
            <div class="mb-4">
                <h3 class="text-lg font-medium text-gray-900">{{ transferInventoryForm.material_name }} （保管日：{{ formatDate(transferInventoryForm.storage_date ?? '') }}，有効期限：{{ formatDate(transferInventoryForm.expiration_date ?? '') }}）</h3>
            </div>
            
            <!-- Create New Record Button (Above Table) -->
            <!-- <div 
                class="w-full mb-2 new-record-fake-row cursor-pointer border border-gray-300 rounded"
                @click="handleCreateNewRecord">
                <div class="flex items-center px-4 h-full">
                    <span 
                        class="material-symbols-outlined text-white mr-3"
                        style="font-size: 20px;">
                        add
                    </span>
                    <span class="text-white font-medium">新しい在庫レコードを作成</span>
                </div>
            </div> -->

            <el-table 
                v-loading="targetInventoryListLoading"
                :data="sortedPaginatedTargetInventory" 
                style="width: 100%"
                highlight-current-row
                header-row-class-name="table-header-row">
                <el-table-column 
                    label=""
                    width="50"
                    align="center">
                    <template #default="{ row }">
                        <div class="flex justify-center items-center w-full h-full">
                            <el-radio 
                                :model-value="selectedTargetInventory.inventory_id"
                                :label="row.inventory_id"
                                @update:model-value="handleTargetInventorySelect(row)"
                                class="radio-center">
                                <span></span>
                            </el-radio>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="storage_date" 
                    width="120"
                    align="left">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('storage_date')">
                            <span>{{ getTargetInventorySortLabel('storage_date') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'storage_date' }">
                                    {{ getTargetInventorySortIcon('storage_date') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                    <template #default="{ row }">
                        {{ formatDate(row.storage_date) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="expiration_date" 
                    width="120"
                    align="left">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('expiration_date')">
                            <span>{{ getTargetInventorySortLabel('expiration_date') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'expiration_date' }">
                                    {{ getTargetInventorySortIcon('expiration_date') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                    <template #default="{ row }">
                        {{ formatDate(row.expiration_date) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="quantity" 
                    width="100"
                    align="left">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('quantity')">
                            <span>{{ getTargetInventorySortLabel('quantity') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'quantity' }">
                                    {{ getTargetInventorySortIcon('quantity') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="location" 
                    min-width="120">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('location')">
                            <span>{{ getTargetInventorySortLabel('location') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'location' }">
                                    {{ getTargetInventorySortIcon('location') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="comment" 
                    min-width="120">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('comment')">
                            <span>{{ getTargetInventorySortLabel('comment') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'comment' }">
                                    {{ getTargetInventorySortIcon('comment') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!-- Pagination controls for target inventory table -->
            <div class="flex justify-end mt-4" v-if="targetInventoryTotal > targetInventoryPageSize">
                <el-pagination
                    v-model:current-page="targetInventoryCurrentPage"
                    :page-size="targetInventoryPageSize"
                    :total="targetInventoryTotal"
                    layout="prev, pager, next"
                    @current-change="handleTargetInventoryPageChange"
                />
            </div>
        </div>

        <template #footer>
            <div class="dialog-footer flex flex-col">
                <div class="flex justify-end mb-2 min-h-6">
                    <div v-if="selectedTargetInventoryError" class="text-red-500 text-sm">
                        {{ selectedTargetInventoryError }}
                    </div>
                </div>

                <div class="flex items-center">
                    <div class="flex gap-2 ml-auto">
                        <el-button @click="selectedTargetInventorydialogFormVisible = false">キャンセル</el-button>
                        <el-button type="primary" @click="handleSelectedTargetInventorySubmit">
                            払い出し
                        </el-button>
                    </div>
                </div>
            </div>
        </template>
    </el-dialog>

    <!-- メモ編集对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="memoDialogVisible" style="max-width:800px"
        title="メモ編集" align-center>
        <el-input
            type="textarea"
            v-model="memo"
            :autosize="{ minRows: 3, maxRows: 8 }"
        ></el-input>
        <template #footer> 
            <div class="dialog-footer">
                <el-button @click="memoDialogVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleMemoSubmit">
                    保存
                </el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 零库存删除对话框 -->
    <el-dialog 
        class="custom-dialog" 
        modal-class="custom-dialog-modal" 
        v-model="zeroQuantityDialogVisible" 
        style="max-width:800px"
        title="在庫数 0 のレコード削除" 
        align-center>
        
        <el-table 
            ref="zeroQuantityTableRef"
            :data="zeroQuantityList" 
            style="width: 100%"
            @selection-change="handleZeroQuantitySelection">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="material_name" label="アイテム名" min-width="380" />
            <el-table-column prop="storage_date" label="保管日" width="100" align="center">
                <template #default="scope">
                    {{ formatDate(scope.row.storage_date) }}
                </template>
            </el-table-column>
            <el-table-column prop="expiration_date" label="有効期限" width="100" align="center">
                <template #default="scope">
                    <span :class="{ 'text-red-500': isExpired(scope.row.expiration_date) }">
                        {{ formatDate(scope.row.expiration_date) }}
                    </span>
                </template>
            </el-table-column>
        </el-table>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="zeroQuantityDialogVisible = false">キャンセル</el-button>
                <el-button type="danger" @click="handleDeleteZeroQuantity">
                    削除
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn, FormInstance, FormRules } from 'element-plus';
import { computed, defineComponent, nextTick, onMounted, ref, } from 'vue';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { SearchRequest } from '@/components/common/request';
import moment from 'moment';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import CategorySelect from '../common/CategorySelect.vue';
import { ROLES, ROUTES, ALL } from '@/config/constants';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import ImgLoading from '@/components/common/ImgLoading.vue';
import router from '@/router';
import AlertStatusIndicators from '@/components/inventory/AlertStatusIndicators.vue';
import { AlarmInfo, InventoryInfo } from '../inventory/type';
import { SortConfig, sortingUtil } from '../common/SortingUtil';
import { CircleCloseFilled, Loading, SuccessFilled} from '@element-plus/icons-vue';

export default defineComponent({
    name: 'MngPayment',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        AutoCompleteInput,
        OrganizationSelect,
        DepartmentSelect,
        CategorySelect,
        AlertStatusIndicators,
        ImgLoading,
        Loading,
        CircleCloseFilled,
        SuccessFilled
    },

    setup() {
        const loginUserRole = localStorage.getItem('role');
        const loginUserIsPayMust = localStorage.getItem('is_pay_must');
        const loginUserOrgId = localStorage.getItem('organization_id') ?? '';

        const searchForm = ref<any>({
            material_code: '',
            organization_id: '',
            target_department_id: '',
            target_department_name: '',
            dest_department_id: '',
            dest_department_name: '',
            category_id: ALL,
            material_name: '',
        });

        const payForm = ref<any>({
            organization_id: '',
            target_department_id: '',
            dest_department_id: '',
            details: [],
            transfer_operator: '',
        });

        const payFormRef = ref<FormInstance>();
        const payRules = ref<FormRules>({
            transfer_operator: [
                { required: loginUserIsPayMust === '1', message: '操作者を入力してください', trigger: 'blur' },
            ],
        });

        const loading2 = ref<boolean>(false);
        const processing = ref<boolean>(false);

        const memoDialogVisible = ref<boolean>(false);
        const memo = ref<string>('');
        const memoRow = ref<InventoryInfo | null>(null);


        const openMemoDialog = (row: InventoryInfo) => {
            memoRow.value = row;
            memoDialogVisible.value = true;
            memo.value = row.transfer_memo ?? '';
        };

        const handleMemoSubmit = () => {
            if (memoRow.value) {
                memoRow.value.transfer_memo = memo.value;
            }
            memoDialogVisible.value = false;
        };

        const transferInventoryForm = ref<InventoryInfo>({
            inventory_id: '',
            sk: '',
            material_code: '',
            organization_id: '',
            department_id: '',
            category_id: '',
            quantity: 0,
            expiration_date: '',
            transfer_memo: '',
        });

        const targetInventoryList = ref<InventoryInfo[]>([]);
        const targetInventoryListLoading = ref<boolean>(false);
        const selectedTargetInventory = ref<{inventory_id: string, sk: string}>({
            inventory_id: '',
            sk: ''
        });
        const selectedTargetInventoryError = ref('');

        const searchFormRef = ref<FormInstance>();
        const searchRules = ref<FormRules>({
            organization_id: [
                { required: true, message: '組織を選択してください', trigger: 'change' }
            ],
            target_department_id: [
                { required: true, message: '払出元部門を選択してください', trigger: 'change' }
            ],
            dest_department_id: [
                { required: true, message: '払出先部門を選択してください', trigger: 'change' }
            ],
        });

        const drawer = ref(false);

        const loading = ref(false);
        const tableData = ref<InventoryInfo[]>([]);          // 排序完成，显示在表格里的数据（单页的数据）
        const allData = ref<InventoryInfo[]>([]);            // 存储所有查询结果
        const totalRecords = ref<number>(0);
        const currentPage = ref<number>(1);
        const pageSize = ref<number>(1000);
        const searchDepartmentId = ref<string | null>(null);

        const selectedTargetInventorydialogFormVisible = ref<boolean>(false);
        const dialogFormVisible = ref<boolean>(false);

        const zeroQuantityTableRef = ref();
        const zeroQuantityDialogVisible = ref<boolean>(false);
        const zeroQuantityList = ref<InventoryInfo[]>([]);
        const selectedZeroQuantityItems = ref<any[]>([]);

        // 排序相关状态
        const sortField = ref<string>('material_name'); // 当前排序字段
        const sortOrder = ref<'asc' | 'desc'>('asc'); // 当前排序方向

        // 排序配置 - 方便添加新的排序字段
        const sortConfig = {
            'material_name': {
                label: 'アイテム名',
                mobileLabel: 'アイテム名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'quantity': {
                label: '在庫数',
                mobileLabel: '在庫数',
                type: 'number' as const,
                defaultOrder: 'desc' as const
            },
            'organization_name': {
                label: '組織',
                mobileLabel: '組織',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'department_name': {
                label: '部署',
                mobileLabel: '部署',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'category_name': {
                label: 'カテゴリ',
                mobileLabel: 'カテゴリ',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'storage_date': {
                label: '保管日',
                mobileLabel: '保管日',
                type: 'date' as const,
                defaultOrder: 'desc' as const
            },
            'expiration_date': {
                label: '有効期限',
                mobileLabel: '有効期限',
                type: 'date' as const,
                defaultOrder: 'asc' as const
            }
        };

        const targetInventorySortConfig: SortConfig = {
            storage_date: {
                label: '保管日',
                mobileLabel: '保管日',
                type: 'date',
                defaultOrder: 'desc'
            },
            expiration_date: {
                label: '有効期限',
                mobileLabel: '有効期限',
                type: 'date',
                defaultOrder: 'asc'
            },
            quantity: {
                label: '在庫数',
                mobileLabel: '在庫数',
                type: 'number',
                defaultOrder: 'desc'
            },
            location: {
                label: '保管場所',
                mobileLabel: '保管場所',
                type: 'string',
                defaultOrder: 'asc'
            },
            comment: {
                label: 'コメント',
                mobileLabel: 'コメント',
                type: 'string',
                defaultOrder: 'asc'
            }
        };

        const {
            handleSort: handleTargetInventorySort,
            getSortLabel: getTargetInventorySortLabel,
            getSortIcon: getTargetInventorySortIcon,
            paginatedData: sortedPaginatedTargetInventory,
            currentPage: targetInventoryCurrentPage,
            pageSize: targetInventoryPageSize,
            totalRecords: targetInventoryTotal,
            handlePageChange: handleTargetInventoryPageChange,
            sortField: targetInventorySortField,
        } = sortingUtil(
            targetInventoryList,
            targetInventorySortConfig
        );

        // 生命周期
        onMounted(async () => {
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
                return;
            }

            // ==================== [Change Block Start] 可回退: 非系统用户固定组织ID ====================
            // 修改前:
            // (无该段)
            if (loginUserRole !== ROLES.SYSTEM) {
                searchForm.value.organization_id = loginUserOrgId;
            }
            // ==================== [Change Block End] 可回退 ====================

        });

        // 方法
        const getInventoryList = async () => {
            try {
                loading.value = true;

                const params: SearchRequest = {
                    material_code: searchForm.value.material_code,
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_id: searchForm.value.target_department_id === ALL ? '' : searchForm.value.target_department_id,
                    dest_department_id: searchForm.value.dest_department_id === ALL ? '' : searchForm.value.dest_department_id,
                    category_id: searchForm.value.category_id === ALL ? '' : searchForm.value.category_id,
                    material_name: searchForm.value.material_name,
                };

                const res: AxiosResponse<ResponseData<InventoryInfo[]> & { level?: number }> = await axios.get('/api/payment/search', { params });
                
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    searchDepartmentId.value = searchForm.value.target_department_id === ALL ? null : searchForm.value.target_department_id;

                    const { total, data, hasMoreData } = res.data;

                    totalRecords.value = total || 0;
                    
                    // 完全重置所有展开状态和详情数据
                    const processedData = (data || []).map(item => ({
                        ...item,
                        payMode: (item.dest_count ?? 0) > 0 ? (item.dest_inventory_id ? 2 : 1) : 0, // 新增属性，初始化为0
                        payQuantity: 0, // 新增属性，初始化为0
                        is_create_new_record: (item.dest_count ?? 0) === 0,
                        is_transfer: (item.dest_count ?? 0) > 0,
                    }));
                    
                    allData.value = processedData;
                    
                    // 计算分页
                    calculatePagination();

                    // 如果有更多数据，显示提示信息
                    if (hasMoreData) {
                        ElMessage({
                            message: '検索結果が1000件を超えています。より詳細な検索条件を設定してください。',
                            type: 'warning',
                            duration: 5000,
                            showClose: true
                        });
                    }
                } else {
                    ElMessage.error(getErrorMessage(PageType.PAYMENT, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.PAYMENT));
            } finally {
                loading.value = false;
            }
        };

        // 前端分页和排序方法
        const handleSizeChange = (size: number) => {
            pageSize.value = size;
            calculatePagination();
        };
        
        const handleCurrentChange = (page: number) => {
            currentPage.value = page;
            calculatePagination();
        };

        /***** ボタン **************************/
        const handleSearchButton = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    drawer.value = false;
                    getInventoryList();
                }
            })
        };

        const handlePayModeButton = (row: InventoryInfo) => {
            selectedTargetInventorydialogFormVisible.value = true;
            nextTick(() => {
                transferInventoryForm.value = row;

                selectedTargetInventory.value = {
                    inventory_id: row.dest_inventory_id ?? '',
                    sk: row.dest_sk ?? '',
                };
                selectedTargetInventoryError.value = '';

                getTargetInventoryList(row);
            });
        }

        const handleProcessButton = () => {
            const filterData = tableData.value.filter(item => (item.payQuantity ?? 0) > 0);
            if(filterData.length === 0) {
                ElMessage.warning('払出数量を入力してください');
                return;
            }

            dialogFormVisible.value = true;
            processing.value = false;
            nextTick(() => {
                loading2.value = true;

                setTimeout(() => {
                    payForm.value = {
                        organization_id: searchForm.value.organization_id,
                        target_department_id: searchForm.value.target_department_id,
                        dest_department_id: searchForm.value.dest_department_id,
                        details: filterData,
                        transfer_operator: '',
                    };

                    loading2.value = false;
                }, 500); // 延迟 500 毫秒
            });
        };

        const formatDate = (date: string) => {
            return moment(date).format('YYYY/MM/DD');
        };

        const isExpired = (date: string) => {
            return moment(date).isBefore(moment(), 'day');
        };

        const getImgUrls = (images: string) => {
            let bufImages: string[] = images.split(',');
            return bufImages;
        };

        // 获取排序图标
        const getSortIcon = (field: string) => {
            if (sortField.value !== field) {
                return 'unfold_more'; // 未排序状态
            }
            return sortOrder.value === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        };

        // 获取排序字段的标签
        const getSortLabel = (field: string) => {
            const config = sortConfig[field as keyof typeof sortConfig];
            return config ? config.label : field;
        };

        // 处理排序
        const handleSort = (field: string) => {
            if (sortField.value === field) {
                // 如果点击的是当前排序字段，切换排序方向
                sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
            } else {
                // 如果点击的是新字段，使用该字段的默认排序方向
                sortField.value = field;
                sortOrder.value = sortConfig[field as keyof typeof sortConfig]?.defaultOrder || 'asc';
            }
            calculatePagination();
        };

        // 比较函数工厂
        const createComparator = (field: string, order: 'asc' | 'desc') => {
            const config = sortConfig[field as keyof typeof sortConfig];
            const fieldType = config?.type || 'string';
            
            return (a: InventoryInfo, b: InventoryInfo) => {
                let aValue: any = a[field as keyof InventoryInfo];
                let bValue: any = b[field as keyof InventoryInfo];
                
                // 根据字段类型进行特殊处理
                switch (fieldType) {
                    case 'number':
                        aValue = Number(aValue) || 0;
                        bValue = Number(bValue) || 0;
                        break;
                    case 'date':
                        aValue = aValue ? new Date(aValue).getTime() : 0;
                        bValue = bValue ? new Date(bValue).getTime() : 0;
                        break;
                    case 'string':
                        if (typeof aValue === 'string' && typeof bValue === 'string') {
                            aValue = aValue.toLowerCase();
                            bValue = bValue.toLowerCase();
                        }
                        break;
                }
                
                // 处理空值
                if (aValue === null || aValue === undefined) aValue = '';
                if (bValue === null || bValue === undefined) bValue = '';
                
                let comparison = 0;
                if (aValue < bValue) comparison = -1;
                if (aValue > bValue) comparison = 1;
                
                // 根据排序方向返回结果
                return order === 'asc' ? comparison : -comparison;
            };
        };

        // 前端分页计算（支持多项目排序）
        const calculatePagination = () => {
            // 使用比较函数工厂创建排序函数
            const comparator = createComparator(sortField.value, sortOrder.value);
            
            // 对数据进行排序
            const sortedData = [...allData.value].sort(comparator);
            
            // 计算分页
            const startIndex = (currentPage.value - 1) * pageSize.value;
            const endIndex = startIndex + pageSize.value;
            
            tableData.value = sortedData.slice(startIndex, endIndex);
            totalRecords.value = allData.value.length;
        };

        const handleTargetDepartmentNameChange = (name: string) => {
            searchForm.value.target_department_name = name;
        };

        const handleDestDepartmentNameChange = (name: string) => {
            searchForm.value.dest_department_name = name;
        };

        const handleSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;

            let isValid = false;
            await formEl.validate((valid, fields) => {
                isValid = valid;
            });

            if (!isValid) {
                return;
            }

            processing.value = true;

            try {
                const details = payForm.value.details;
                for (let i = 0; i < details.length; i++) {
                    const item = details[i];

                    // 处理 transfer_memo：将 transfer_operator 加在 memo 前面，并加上换行
                    let processedMemo = item.transfer_memo ?? '';
                    if (payForm.value.transfer_operator && payForm.value.transfer_operator.trim()) {
                        processedMemo = '\n' + "操作者：" + payForm.value.transfer_operator.trim() + '\n' + processedMemo;
                    }

                    const commonTransferInventory = {
                        inventory_id: item.inventory_id,
                        sk: item.sk,
                        storage_date: item.storage_date ?? '',
                        expiration_date: item.expiration_date ?? '',
                        organization_id: item.organization_id ?? '',
                        organization_name: item.organization_name ?? '',
                        department_id: item.department_id ?? '',
                        department_name: item.department_name ?? '',
                        material_code: item.material_code ?? '',
                        material_name: item.material_name ?? '',
                        comment: item.comment ?? '',
                        location: item.location ?? '',
                        quantity: item.quantity ?? 0,
                        dest_department_id: searchForm.value.dest_department_id ?? '',
                        dest_department_name: searchForm.value.dest_department_name ?? '',
                        transfer_memo: processedMemo,
                        transfer_quantity: item.payQuantity ?? 0,
                        is_transfer: false,
                        is_create_new_record: false,
                    };

                    let transferInventory;
                    if(item.payMode == 0){ // 新規
                        transferInventory = {
                            ...commonTransferInventory,
                            dest_inventory_id: item.dest_inventory_id ?? '',
                            dest_sk: item.dest_sk ?? '',
                            is_create_new_record: item.is_create_new_record ?? false 
                        }

                    } else if(item.payMode == 1 || item.payMode == 2){ // 選択 or 追加
                        transferInventory = {
                            ...commonTransferInventory,
                            dest_inventory_id: item.dest_inventory_id ?? '',
                            dest_sk: item.dest_sk ?? '',
                            is_transfer: item.is_transfer ?? false 
                        }
                    }

                    const postData = {
                        ...transferInventory,
                    };

                    item.process_status=  0; // 処理中
                    const res: AxiosResponse<ResponseData<AlarmInfo[]>> = await axios.post(`/api/inventories2/transfer`, postData);
                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        item.process_status= 1; // 成功
                    } else {
                        item.process_status= 2; // 失败
                    }
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                await getInventoryList();

                // 检查是否有数量为 0 的库存
                if (allData.value.some(item => item.quantity === 0)) {
                    dialogFormVisible.value = false;
                    openZeroQuantityDialog();
                }
            }
        };

        const handleZeroQuantitySelection = (selection: InventoryInfo[]) => {
            selectedZeroQuantityItems.value = selection.map(item => { return { inventory_id: item.inventory_id, sk: item.sk }; });
        };

        const openZeroQuantityDialog = () => {
            zeroQuantityList.value = allData.value.filter(item => item.quantity === 0);
            // 默认全选
            selectedZeroQuantityItems.value = zeroQuantityList.value.map(item => { return { inventory_id: item.inventory_id, sk: item.sk }; });
            zeroQuantityDialogVisible.value = true;

            // 等待 DOM 渲染后全选
            nextTick(() => {
                if (zeroQuantityTableRef.value) {
                    zeroQuantityTableRef.value.toggleAllSelection();
                }
            });
        };

        const handleDeleteZeroQuantity = () => {
            if (selectedZeroQuantityItems.value.length === 0) {
                ElMessage.warning('削除するレコードを選択してください');
                return;
            }

            ElMessageBox.confirm('レコードを削除しますか？', '確認', {
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
                type: 'warning',
            }).then(() => {
                deleteZeroQuantity();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const deleteZeroQuantity = async () => {
            try {
                zeroQuantityDialogVisible.value = false;
                loading.value = true;
                
                const deletePromises = selectedZeroQuantityItems.value.map(item => {
                    return axios.delete(`/api/inventories2/${item.inventory_id}`, {
                            data: {
                                sk: item.sk
                            }
                    });
                });

                await Promise.all(deletePromises);

                ElMessage.success('選択したレコードを削除しました');
            } catch (error) {
                ElMessage.error('削除に失敗しました');
            } finally {
                await getInventoryList();
            }
        };

        const getTargetInventoryList = async (row: InventoryInfo) => {
            try {
                targetInventoryListLoading.value = true;

                const res: AxiosResponse<ResponseData<InventoryInfo[]>> = await axios.get(`/api/inventories2/searchLevel3`, {
                    params: {
                        organization_id: row.organization_id,
                        department_id: searchForm.value.dest_department_id, // Use destination department for target inventory
                        material_code: row.material_code,
                        storage_date: row.storage_date,
                        expiration_date: row.expiration_date,
                        page: 1,
                        limit: 1000 // Get more data for client-side pagination
                    }
                });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    targetInventoryList.value = res.data.data || [];
                } else {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                targetInventoryListLoading.value = false;
            }
        }

        const handleTargetInventorySelect = (row: any) => {
            selectedTargetInventory.value.inventory_id = row.inventory_id;
            selectedTargetInventory.value.sk = row.sk;
        };

        const handleCreateNewRecord = () => {
            transferInventoryForm.value.payMode = 0;
            transferInventoryForm.value.dest_inventory_id = '';
            transferInventoryForm.value.dest_sk = '';
            transferInventoryForm.value.is_create_new_record = true;
            transferInventoryForm.value.is_transfer = false;
            
            selectedTargetInventorydialogFormVisible.value = false;
        };

        const handleSelectedTargetInventorySubmit = () => {
            if(!selectedTargetInventory.value.inventory_id || selectedTargetInventory.value.inventory_id === '') {
                selectedTargetInventoryError.value = '先在庫を選択してください';
                return;
            }

            selectedTargetInventoryError.value = '';

            transferInventoryForm.value.payMode = 1;
            transferInventoryForm.value.dest_inventory_id = selectedTargetInventory.value.inventory_id;
            transferInventoryForm.value.dest_sk = selectedTargetInventory.value.sk;
            transferInventoryForm.value.is_create_new_record = false;
            transferInventoryForm.value.is_transfer = true;

            selectedTargetInventorydialogFormVisible.value = false;
        };

        const handlePayQuantityChange = (row: any) => {
            if(row.payMode !== 0 && !row.dest_inventory_id){
                row.payQuantity = 0;
                handlePayModeButton(row);
            }
        };

        return {
            searchForm,
            drawer,
            loginUserRole,
            ROLES,
            loading,
            dialogFormVisible,
            handleSearchButton,
            handleProcessButton,
            tableData,
            getSortIcon,
            getSortLabel,
            handleSort,
            sortField,
            formatDate,
            isExpired,
            getImgUrls,
            handleSizeChange,
            handleCurrentChange,
            totalRecords,
            pageSize,
            currentPage,
            searchRules,
            searchFormRef,
            handleSubmit,
            payForm,
            payFormRef,
            payRules,
            handleTargetDepartmentNameChange,
            handleDestDepartmentNameChange,
            handlePayQuantityChange,
            targetInventoryListLoading,
            loading2,
            processing,
            handleTargetInventoryPageChange,
            handleTargetInventorySort,
            getTargetInventorySortLabel,
            getTargetInventorySortIcon,
            sortedPaginatedTargetInventory,
            targetInventoryCurrentPage,
            targetInventoryPageSize,
            targetInventoryTotal,
            targetInventorySortField,
            handleTargetInventorySelect,
            selectedTargetInventorydialogFormVisible,
            handlePayModeButton,
            transferInventoryForm,
            handleCreateNewRecord,
            handleSelectedTargetInventorySubmit,
            selectedTargetInventoryError,
            selectedTargetInventory,
            memoDialogVisible,
            memo,
            openMemoDialog,
            handleMemoSubmit,
            zeroQuantityDialogVisible,
            zeroQuantityList,
            selectedZeroQuantityItems,
            handleDeleteZeroQuantity,
            handleZeroQuantitySelection,
            zeroQuantityTableRef,
        };
    },
});
</script>

<style scoped>
.thumbnail {
    width: 30px;
    height: 30px;
    object-fit: cover;
}

.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

.new-record-fake-row {
    background-color: #409eff;
    color: white;
    transition: background-color 0.2s ease;
    height: 40px; /* Match table header height */
}

.new-record-fake-row:hover {
    background-color: #337ecc;
}

/* Table header styling */
:deep(.table-header-row) {
    background-color: black !important;
    color: white !important;
}

:deep(.table-header-row th) {
    background-color: black !important;
    color: white !important;
    border-color: #374151 !important;
}

/* Center radio button properly */
.radio-center {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.radio-center .el-radio__input) {
    margin: 0 auto;
}

:deep(.radio-center .el-radio__label) {
    padding: 0;
}

/* Remove vertical separator lines from table */
:deep(.el-table td),
:deep(.el-table th) {
    border-right: none !important;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>